import React from 'react';
import styled from 'styled-components';
import { PaddedContainer } from './styles';
import Disclaimer from './disclaimer';
import Copyright from './copyright';

const Background = styled.div`
  background-color: ${props => props.theme.secondaryColorLight};
`;

const Container = styled(PaddedContainer)`
  display: flex;
  ${props => (props.theme.isMobile ? `
    flex-direction: column;
    align-items: start;
    padding: 42px 0;
  ` : `
    height: 70px;
    align-items: center;
    justify-content: space-between;
    &:after {
      order: 2;
      content: "";
      width: 18vw;
      max-width: 600px;
    }
  `)};
`;

const Tcp = styled.div`
  order: 3;
  display: flex;
  justify-content: space-between;
  width: 270px;

  > a {
    color: ${props => props.theme.secondaryColor};
    font-family: ${props => props.theme.fontFamilyBody};
    font-weight: ${props => props.theme.fontWeightBold};
    font-size: 12px;
  }
`;

const SocialMedia = styled.div`
  order: ${props => (props.theme.isMobile ? 1 : 4)};
  display: flex;
  width: 101px;
  justify-content: space-between;

  > a {
    color: ${props => props.theme.secondaryColor};
  }
`;

const Icon = styled(props => <span className={`icon-lw icon-lw-${props.name}`} />)`
  font-size: 20px;
`;

const Divider = styled.hr`
  order: 4;
  width: 100%;
  height: 0px;
  border-top: 1px solid #bbcbd8;
  margin-top: 42px;
  display: ${props => (props.theme.isMobile ? 'block' : 'none')};
`;

export default function Footer() {
  return (
    <>
      <Disclaimer />
      <Background>
        <Container>
          <Copyright />
          <Tcp>
            <a href="/company/terms_and_conditions">
              Terms and Conditions
            </a>
            <a href="/company/privacy">
              Privacy
            </a>
            <a href="/company/house_rules">
              House Rules
            </a>
          </Tcp>
          <SocialMedia>
            <a href="https://x.com/livewiremarkets" target="_blank" rel="noopener noreferrer">
              <svg
                width="20"
                height="20"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M36.6526 3.80762H43.3995L28.6594 20.6546L46 43.5796H32.4225L21.7881 29.6757L9.61989 43.5796H2.86886L18.6349 25.5598L2 3.80762H15.9222L25.5348 16.5163L36.6526 3.80762ZM34.2846 39.5412H38.0232L13.8908 7.63388H9.87892L34.2846 39.5412Z"
                  fill="rgb(142,163,181)"
                />
              </svg>
            </a>
            <a
              href="//www.instagram.com/livewire.markets/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="instagram" />
            </a>
            <a href="//www.facebook.com/livewiremarkets/" target="_blank" rel="noopener noreferrer">
              <Icon name="facebook" />
            </a>
            <a
              href="//au.linkedin.com/company/livewire-markets"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon name="linkedin" />
            </a>
          </SocialMedia>
          <Divider />
        </Container>
      </Background>
    </>
  );
}
